'use strict';

/*
Extends module.dealers.js !!!
*/

define('modules/module.slp.contact',[
  'jquery',
  './module.dealers',
  'txt!./module.slp.contact.hbs', // full front side
  'txt!./module.slp.contact.backside.hbs', // full backside
  'txt!./module.dealers.results.detail.hbs', // dealer results detail
  'txt!./module.slp.success.hbs', // dealer results detail
  'txt!./module.slp.success.header.hbs', // dealer results detail
  'lib/services/batws',
  'lib/objectifyForm',
  'detectizr',
  'cookies',
  'lib/util/tda.config',

  // Side Effect Includes
  'lib/validator'
], function (
  $,
  DealersModule,
  txtTemplate,
  txtResultsBackside,
  txtDealerDetail,
  txtSuccess,
  txtSuccessHeader,
  batws,
  objectifyForm,
  detectizr,
  cookies,
  tdaConfig
) {
  // the following templates are required when extending a DealersModule
  var __tmplResultsBackside = Handlebars.compile(txtResultsBackside);
  var __tmplSuccess = Handlebars.compile(txtSuccess);
  var __tmplSuccessHeader = Handlebars.compile(txtSuccessHeader);

  var SlpContactModule = DealersModule.extend({
    template: Handlebars.compile(txtTemplate),
    events: function () {
      // add additional events to those found in the DealersModule that
      return Object.assign({}, DealersModule.prototype.events(), {
        'click .success-close': 'showFrontLocal',
        'change input[name="preferedContact"]': 'swapInput'
      });
    },

    staticData: {
      // static SVG displayed inline, is this better? can always switch back to this
      /* all: {
        image: '/assets/img/module/slp/slp-hero.svg'
      }, */
      en: {
        headline: 'Request Information',
        copy: {
          '1x1': '<p>Reach out to a Toyota dealer to schedule a test drive or request a Toyota financial quote.</p>',
          '2x1': '<p>Connect with a Toyota dealer to browse new car deals, certified used cars and used trucks for sale.</p>'
        },
        detailTitle: 'Selected Dealer',
        actions: [
          {
            title: 'Enter ZIP Code or City/State',
            geoLocateLabel: 'Find my location',
            searchLabel: 'Search'
          }
        ],
        dataLayerMore: {
          locate: {
            'link_text': 'geolocate'
          },
          search: {
            'link_text': 'Find a Toyota Dealer'
          }
        }
      },
      es: {
        headline: 'Pedir información',
        copy: {
          '1x1': '<p>Contacta un concesionario Toyota para hacer una prueba de manejo o pedir una cotización.</p>',
          '2x1': '<p>Contacta un concesionario Toyota para ver ofertas en autos nuevos y vehículos usados.</p>'
        },
        detailTitle: 'Selected Dealer',
        actions: [
          {
            title: 'Pon ZIP Code, ciudad o estado',
            geoLocateLabel: 'Buscar mi ubicación',
            searchLabel: 'Buscar'
          }
        ],
        dataLayerMore: {
          locate: {
            'link_text': 'geolocate',
            'dealer_search_term': '',
            'dealer_search_type': 'zip',
            'dealer_search_results_count': '0',
            'dealer_search_brand': 'Toyota',
            'content_section': 'Get_Started'
          },
          search: {
            'link_text': 'Find a Toyota Dealer',
            'dealer_search_term': '', // populated on click
            'dealer_search_type': 'zip',
            'dealer_search_results_count': '0',
            'dealer_search_brand': 'Toyota',
            'content_section': 'Get_Started',
          }
        }
      }
    },

    getTemplateContext: function () {
      return $.extend({}, this.staticData.all, this.staticData[this.getCanvas().getLang()], this.getConfig().data);
    },

    swapInput: function (e) {
      var related = $(e.currentTarget).val();
      this.$form.find('.input-swap').children('input').hide();
      this.$form.find('input[data-radio="' + related + '"]').show();
    },
    // Add any necessary content to the details obj
    addDetailContent: function (detailsObj, currDealerData) {
      var pageTitleObj = {
        en: {
          pageTitle: 'Selected Dealer'
        },
        es: {
          pageTitle: 'Concesionario elegido'
        }
      };

      return Object.assign({}, detailsObj, {
        pageTitle: pageTitleObj[this.getCanvas().getLang()].pageTitle
      });
    },

    localRender: function () {

    },

    // see slp-tools, these are specific to CAD
    /*
    TMBT38450000	Toyota	Mobile	Buyatoyota.com	BAT 2.0 SLP Module 1/3
    TWBT38450000	Toyota	Website	Buyatoyota.com	BAT 2.0 SLP Module 1/3
    TMBT38460000	Toyota	Mobile	Buyatoyota.com	BAT 2.0 SLP Module 2/3
    TWBT38460000	Toyota	Website	Buyatoyota.com	BAT 2.0 SLP Module 2/3
    TMBT38470000	Toyota	Mobile	Buyatoyota.com	BAT 2.0 SLP Module 3/3
    TWBT38470000	Toyota	Website	Buyatoyota.com	BAT 2.0 SLP Module 3/3
    */
    campaignCode: {
      mobile: {
        en: {
          '1x1': 'TMBT38450000',
          // these are not possible, but we DO have the codes setup!
          '2x1': 'TMBT38460000',
          '3x1': 'TMBT38470000'
        },
        es: {
          '1x1': 'TMBT42350000',
          // these are not possible, but we DO have the codes setup!
          '2x1': 'TMBT42360000',
          '3x1': 'TMBT42370000'
        }
      },

      other: {
        en: {
          '1x1': 'TWBT38450000',
          '2x1': 'TWBT38460000',
          '3x1': 'TWBT38470000'
        },
        es: {
          '1x1': 'TWBT42350000',
          '2x1': 'TWBT42360000',
          '3x1': 'TWBT42370000'
        }
      }
    },

    hiddenInputs: function (currDealerData) {
      var lang = this.getCanvas().getLang();
      var campaignDevice = detectizr.device.type === 'mobile' ? 'mobile' : 'other';
      return {
        vehicleMake: 'N/A',
        vehicleModel: 'N/A',
        vehicleYear: 'N/A',
        deviceType: detectizr.device.type,
        mediaTag: cookies.getItem('campaign'),
        omnitureId: cookies.getItem('xact'),
        tmsSiteAttribute: '',
        campaignCode: this.campaignCode[campaignDevice][lang][this.activeLayout],
        dealerCode: currDealerData.dealerCode,
        pma: currDealerData.dealerCode,
        selectDealer: 'zip',
        successPage: window.location.origin + '/' + tdaConfig.site.context_url + '/request-a-quote/thankyou/',
        errorPage: window.location.origin + '/' + tdaConfig.site.context_url + '/request-a-quote/404',
        comments: ''
      };
    },

    // Invoked via drawDefaults in module.dealers.js
    drawLocal: function (currDealerData) {
      var self = this;
      // console.log('new details OBJ', this.addDetailContent(this.details[this.getCanvas().getLang()], currDealerData));
      var header = {
        en: {
          titleMore: '* Required Information',
          titleMoreClass: 'copy-slp',
          actions: [
            {
              title: 'Dealer List',
              url: '#',
            }
          ]
        },
        es: {
          titleMore: '* Obligatorio:',
          titleMoreClass: 'copy-slp',
          actions: [
            {
              title: 'Concesionarios',
              url: '#',
            }
          ]
        }
      };

      self.drawDetailHeader(header);

      self.$backSideContent.html(__tmplResultsBackside({
        layout: self.activeLayout,
        result: currDealerData,
        formVals: self.hiddenInputs(currDealerData),
        details: self.addDetailContent(self.details[self.getCanvas().getLang()], currDealerData),
        drawExtendedDetail: self.drawExtendedDetail.bind(self)
      }));

      if ('3x1' === self.activeLayout) {
        self.drawMap(currDealerData);
      }
      self.$form = $('form', self.$back);
      self.$form.find('input').filter(':visible:first').focus();
      self.$form.validate({
        rules: {
          customerPhone: {
            required: true,
            phoneUS: true
          }
        },
        submitHandler: function (form) {
          var data = objectifyForm(self.$form.serializeArray());
          data.comments = data.commentArea + ' ::REFERRING URL::' + document.URL;
          self.showLoader();
          batws.slp().getQuote(data)
            .then(function (res) {
              // res is just a string of HTML from the success page
              // if error, will we get the same thing?
              // console.log(res);
              self.$backSideHeader.addClass('header-slp-success').html(__tmplSuccessHeader());
              self.$backSideContent.html(__tmplSuccess());
              self.showFrontTimed();
            })
            .catch(function (res) {console.log('error in slp/getQuote/: ', res);});
        }
      });
    },

    clearSlpTimeOut: function () {
      if ( this.currTimeoutId ) {
        clearTimeout(this.currTimeoutId);
      }
    },

    showFrontLocal: function (e) {
      e && e.preventDefault();
      // cancel a potential timeout
      this.clearSlpTimeOut();
      this.showFront();
    },

    showFrontTimed: function () {
      var self = this;
      self.clearSlpTimeOut();
      self.currTimeoutId = setTimeout(function () {
        self.showFront();
      }, 5000);
    },

    drawExtendedDetail: function (ctx) {
      return Handlebars.compile(txtDealerDetail)(ctx);
    }

  });

  return SlpContactModule;
});

